<template>
    <b-row>
        <b-col cols="2">
            <lformcheck :readonly="readonly" :value="IsActive(work)" @change="ActivateValue($event)">
            </lformcheck> {{title}}
        </b-col>
        <b-col>
            <b-form-input v-if="type!='select'&&IsActive(work)" v-model="work"
                @input="TriggerChange()" :readonly="readonly"></b-form-input>
            <lformselect class="form-control" v-if="type=='select'&& IsActive(work)"
                        v-model="work" @input="onselectionchanged()" :options="options" :readonly="readonly">
                </lformselect>
        </b-col>
    </b-row>
</template>
<script>
import lformselect from "@/components/l-form-select.vue"
import lformcheck from "@/components/l-form-check.vue"

export default {
    name: 'stepinput',
    components: {lformcheck,lformselect},
    props: {
        value: String,
        title: String,
        readonly: Boolean,
        type: { type: String, default: 'text'},
        options: Array, //Optionals
    },
    data() {
        return {
            work: null,
        }
    },
    created() {
        this.work = this.value;
    },
    methods: {
        IsActive(v) {
            return !(v === null || v === undefined);
        },
        ActivateValue(e) {
            console.log(e);
            if (e) {
                this.work = ''; //???
                //this.work = e;
            } else {
                this.work = null;
            }
            this.TriggerChange();
            this.$forceUpdate();
            //this.oninput(e);
        },
        TriggerChange() {
            this.$emit('input', this.work);
        },
        onselectionchanged(e) {
            console.log(e);
            this.TriggerChange();
        }
    }
}
</script>